import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWaterNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M40 26a7.777 7.777 0 01-6.96-4.18l-.43-.81h-1.22l-.43.81a7.885 7.885 0 01-13.92 0l-.43-.81h-1.22l-.43.81A7.777 7.777 0 018 26a7.777 7.777 0 01-6.96-4.18L1 21.75v3.36A9.71 9.71 0 008 28a9.727 9.727 0 008-4.07 9.9 9.9 0 0016 0 9.908 9.908 0 0015 1.18v-3.36l-.04.07A7.777 7.777 0 0140 26zM24 41a7.776 7.776 0 01-6.96-4.17l-.44-.82h-1.21l-.43.81A7.777 7.777 0 018 41a7.776 7.776 0 01-6.96-4.17L1 36.75v3.36a9.098 9.098 0 001.9 1.5A9.85 9.85 0 008 43a9.727 9.727 0 008-4.07 9.9 9.9 0 0015 1.17v-3.35l-.04.07A7.777 7.777 0 0124 41zm16-30a7.777 7.777 0 01-6.96-4.18l-.43-.81h-1.22l-.43.81a7.884 7.884 0 01-13.92 0L17 6.75v3.35a9.9 9.9 0 0015-1.17A9.727 9.727 0 0040 13a9.675 9.675 0 007-2.89V6.75l-.04.07A7.766 7.766 0 0140 11z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWaterNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsWaterNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWaterNormalLarge;
